"use client";

import { Dialog, DialogContent } from "@/shadcn/ui/dialog";
import { Drawer, DrawerContent } from "@/shadcn/ui/drawer";
import ModalBody from "./components/ModalBody";
import { useGate } from "statsig-react";
import { useMediaQuery } from "../common/hooks/useMediaQuery";
import { useEffect, useState } from "react";

interface AddPhoneModalProps {
  isOpen: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}

const AddPhoneModal = ({ isOpen, setIsOpen }: AddPhoneModalProps) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const { value: addPhoneFeatureEnabled } = useGate("add_phone_feature");

  // Handle state changes
  const handleOpenChange = (open: boolean) => {
    setIsOpen?.(open); // Notify parent component if callback provided
  };

  if (!addPhoneFeatureEnabled) {
    return null;
  }

  if (!isDesktop) {
    return (
      <Drawer open={isOpen} onOpenChange={handleOpenChange}>
        <DrawerContent className="z-[99] font-regular flex items-center gap-x-4">
          <ModalBody setIsOpen={handleOpenChange} />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="rounded-lg md:w-full md:max-w-md p-9">
        <ModalBody setIsOpen={handleOpenChange} />
      </DialogContent>
    </Dialog>
  );
};

export default AddPhoneModal;
